import Vue from 'vue';
import VueRouter from 'vue-router';
import PageCourse from '@/pages/PageCourse.vue';
import PageThanks from '@/pages/PageThanks.vue';
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', name: 'App' },
        { path: '/submit', name: 'PageSubmit', component: PageThanks },
        { path: '/course', redirect: '/' },
        { path: '/course/:id', name: 'PageCourse', component: PageCourse },
    ],
    scrollBehavior: function (to) {
        if (to.hash) {
            return {
                selector: to.hash
            };
        }
    },
});
export default router;
